import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";
import sections from "fantastic/lib/sections";

export default id => (dispatch, getState) => {
  const node = sections.byId(id, getState().sections);
  if(!node.meta.editable) return;
  dispatch({ type: "SECTIONS/NODE/EDIT", payload: { id, edit: true } });
  dispatch({ type: "APP/HTML/OPEN", payload: { id, value: node.contents } });
};
